import { Injectable } from '@angular/core';
import { QueryOptions } from '../helpers/QueryOptions';

@Injectable({
	providedIn: 'root'
})
export class QueryBuilderService {

	default() : QueryOptions {
		return new QueryOptions();
	}
}